/**
 * Platform-audio catalogue — admin mirror of the public route the
 * web frontend uses (`/api/audio/platform`). The admin template
 * editor and the audio admin page call this to populate the in-built
 * track list.
 */

import { adminApi } from './adminApi';

export interface PlatformAudioTrack {
  id: string;
  title: string;
  artist: string | null;
  url: string;
  duration: number | null;
  mood: string | null;
  genre: string | null;
  language: string;
  isGeneric: boolean;
  isFeatured: boolean;
  tier?: 'FREE' | 'PRO';
  proposalType?: 'MARRIAGE' | 'RELATIONSHIP' | 'DATE' | null;
  coverArtUrl?: string | null;
  metadata: any;
}

export interface PlatformAudioListResponse {
  success: boolean;
  tracks: PlatformAudioTrack[];
  total: number;
  page: number;
  limit: number;
  pages: number;
  filters: { mood?: string; genre?: string; proposalType?: string; language?: string };
}

export async function listPlatformAudio(filters?: {
  mood?: string;
  genre?: string;
  proposalType?: string;
  language?: string;
  page?: number;
  limit?: number;
}): Promise<PlatformAudioListResponse> {
  const params = new URLSearchParams();
  if (filters?.mood) params.set('mood', filters.mood);
  if (filters?.genre) params.set('genre', filters.genre);
  if (filters?.proposalType) params.set('proposalType', filters.proposalType);
  if (filters?.language) params.set('language', filters.language);
  if (filters?.page) params.set('page', String(filters.page));
  if (filters?.limit) params.set('limit', String(filters.limit));
  const qs = params.toString();
  const res = await adminApi.get<PlatformAudioListResponse>(
    `/audio/platform${qs ? `?${qs}` : ''}`,
  );
  return res;
}
